var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"box is-shadowless"},'div',_vm.$attrs,false),[_c('div',{staticClass:"loader-wrapper",class:{ 'is-active': _vm.value }},[_c('div',{staticClass:"loader is-loading"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }